<template>
    <ul
        role="tablist"
        :class="[
            'SideNav',
            open && size > 657 && 'SideNav--open'
        ]"
    >
        <Header
            :home-url="homeUrl"
            :open="open && size > 657"
            @navigate="nav"
            @toggle-open="bool => open = bool"
        />
        <template v-if="size > 657">
            <Section
                v-for="section in sections"
                :key="section.key"
                :section="section"
                :is-active="section.key === activeSection.key"
                :open="open"
                @navigate="nav"
            />
        </template>
        <RPModal v-if="size <= 657 && open">
            <template v-slot:modal>
                <div class="SideNav__modal">
                    <Header
                        :home-url="homeUrl"
                        :open="true"
                        @navigate="nav"
                        @toggle-open="bool => open = bool"
                    />
                    <Section
                        v-for="section in sections"
                        :key="section.key"
                        :section="section"
                        :is-active="section.key === activeSection.key"
                        :open="true"
                        @navigate="nav"
                    />
                </div>
            </template>
        </RPModal>
    </ul>
</template>
<script>

import stat from 'status/index';
import Header from './SideNav/Header.vue';
import Section from './SideNav/Section.vue';
import RPModal from 'components/Complex/Modal/RPModal.vue';

export default {
    name: 'RPSideNav',
    components: {
        Header,
        Section,
        RPModal,
    },
    props: {
        homeUrl: {
            type: String,
            default: ''
        },
        /**
        * See `RPDashboardLayout` for prop details
        */
        sections: {
            type: Array,
            required: true
        },
        /**
        * See `RPDashboardLayout` for prop details
        */
        activeSection: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
            size: 1000,
            open: false,
        };
    },
    destroyed(){
        document.removeEventListener('resize', this.resize);
    },
    mounted() {
        window.addEventListener('resize', this.resize);
        this.resize();
    },
    methods: {
        resize(){
            this.size = Math.min(window.innerWidth, window.screen.width);
        },
        nav(to){
            this.open = false;
            this.$emit('navigate', to);
        }
    }
};
</script>
<style lang="scss">
    .SideNav {
        height: inherit;
        background: $primary-400;
        list-style: none;
        padding: 0 0.5rem;
        margin: 0;

        &--open { padding: 0; }

        &__modal {
            background: $primary-400;
        }
    }

</style>